// @flow
import type JourneyType from "common/records/Journey"
import mapperPriorityBoarding from "./services/mapperPriorityBoarding"
import type {
  PriorityBoarding,
  PriorityBoardingInput,
  PriorityBoardingOrdered,
} from "booking/services/additionalServices/services/priorityBoarding/services/types"

type SetPriorityBoardingData = {
  type: "SET_PRIORITY_BOARDING_DATA",
  payload: PriorityBoarding,
}

type SetPriorityBoardingOrdered = {
  type: "SET_PRIORITY_BOARDING_ORDERED",
  payload: PriorityBoardingOrdered,
}

export type SetPriorityBoardingForPassengerOneFlight = {
  type: "SET_PRIORITY_BOARDING_FOR_PASSENGER_ONE_FLIGHT",
  payload: {
    flightId: string,
    passenger: number,
    ordered: boolean,
  },
}

export type SetPriorityBoardingForPassengersOneFlight = {
  type: "SET_PRIORITY_BOARDING_FOR_PASSENGERS_ONE_FLIGHT",
  payload: {
    flightId: string,
    passengers: Array<number>,
    ordered: boolean,
  },
}

type SetPriorityBoardingForPassengerAllFlights = {
  type: "SET_PRIORITY_BOARDING_FOR_PASSENGER_ALL_FLIGHTS",
  payload: {
    flightsIds: string[],
    passenger: number,
    ordered: boolean,
  },
}

type RemovePriorityBoardingForPassengers = {
  type: "REMOVE_PRIORITY_BOARDING_FOR_PASSENGERS",
  payload: {
    passengerIndexes: number[],
  },
}

type SplicePassengers = {
  type: "SPLICE_PASSENGERS",
  payload: {
    index: number,
    newNumOfPassengers: number,
  },
}

export type Action =
  | SetPriorityBoardingForPassengerOneFlight
  | SetPriorityBoardingOrdered
  | SetPriorityBoardingData
  | SetPriorityBoardingForPassengerAllFlights
  | SplicePassengers
  | SetPriorityBoardingForPassengersOneFlight
  | RemovePriorityBoardingForPassengers

// Actions
// ===
export const setPriorityBoardingData = (input: PriorityBoardingInput): SetPriorityBoardingData => ({
  type: "SET_PRIORITY_BOARDING_DATA",
  payload: mapperPriorityBoarding(input),
})

export const setPriorityBoardingOrdered = (
  input: PriorityBoardingOrdered,
): SetPriorityBoardingOrdered => ({
  type: "SET_PRIORITY_BOARDING_ORDERED",
  payload: input,
})

export const setPriorityBoardingOneFlight = (
  flightId: string,
  passenger: number,
  ordered: boolean,
): SetPriorityBoardingForPassengerOneFlight => ({
  type: "SET_PRIORITY_BOARDING_FOR_PASSENGER_ONE_FLIGHT",
  payload: {
    flightId,
    passenger,
    ordered,
  },
})

export const setPriorityBoardingOneFlightPassengers = (
  flightId: string,
  passengers: Array<number>,
  ordered: boolean,
): SetPriorityBoardingForPassengersOneFlight => ({
  type: "SET_PRIORITY_BOARDING_FOR_PASSENGERS_ONE_FLIGHT",
  payload: {
    flightId,
    passengers,
    ordered,
  },
})

export const setPriorityBoardingAllFlights = (
  passenger: number,
  ordered: boolean,
  journey: JourneyType,
) => ({
  type: "SET_PRIORITY_BOARDING_FOR_PASSENGER_ALL_FLIGHTS",
  payload: {
    flightsIds: journey
      .getFlights()
      .filter(flight => flight.priorityBoarding)
      .map(flight => flight.id)
      .toArray(),
    passenger,
    ordered,
  },
})

export const removePriorityBoardingForPassengers = (
  passengerIndexes: Array<number>,
): RemovePriorityBoardingForPassengers => ({
  type: "REMOVE_PRIORITY_BOARDING_FOR_PASSENGERS",
  payload: {
    passengerIndexes,
  },
})

export const setPriorityBoardingSpecificFlights = (
  passenger: number,
  ordered: boolean,
  flightsIds: string[],
) => ({
  type: "SET_PRIORITY_BOARDING_FOR_PASSENGER_ALL_FLIGHTS",
  payload: {
    flightsIds,
    passenger,
    ordered,
  },
})

// Passenger at {index},
// we need to move all values for passengers with greater indexes to index - 1 (splice).
export const splicePassengers = (index: number, newNumOfPassengers: number): SplicePassengers => ({
  type: "SPLICE_PASSENGERS",
  payload: {
    index,
    newNumOfPassengers,
  },
})
